import {texts as appTexts } from '../../../AppData';
import { getContextFromUrl, properties as propertiesCloudConfig } from 'config/Config';


export const texts = {
    PAGE_TITLE: 'Aportar documentación',
    TEXT_DOCUMENTACION_A_APORTAR: 'Documentación a aportar',
    TEXT_BOTON: 'VOLVER A LA BANDEJA DE ENTRADA',
    TEXT_FIRMAR: 'INICIAR FIRMAR',
    TEXT_FIRMAR_SMS: 'INICIAR FIRMA SMS',
    TITULO_ERROR: "Se ha producido un error",
    TEXTO_ERROR_DROP_REJECTED1: "Tenga en cuenta que el documento deber ser un PDF con un tamaño máximo de ",
    TEXTO_ERROR_DROP_REJECTED2: " MB. Por favor, seleccione otro documento que cumpla con las condiciones indicadas.",
    TEXTO_ERROR_DROP_REJECTED3: "Tenga en cuenta que el archivo debe ser un video con uno de los siguientes formatos permitidos: ",
    TEXTO_ERROR_DROP_REJECTED4: "Tenga en cuenta que el archivo debe ser una imagen con uno de los siguientes formatos permitidos: ",
    TEXTO_ERROR_DROP_REJECTED5:" y un tamaño máximo de ",
    TEXTO_ERROR_DROP_REJECTED6: " MB. Por favor, seleccione otro archivo que cumpla con las condiciones indicadas.",
    TEXTO_ERROR_DROP_REJECTED7: "Tenga en cuenta que el archivo debe ser un PDF, un video o una imagen con uno de los siguientes formatos permitidos: .PDF,",
    TEXTO_TAMAÑO_MAX_ANEXO: 'Tamaño maximo por anexo: ',
    TEXTO_MB:'MB',
    TITULO_CONFIRMACION_FIRMA: "Aporte de documentación",
    MSG_CONFIRMACION_FIRMA: "¿Desea iniciar la presentación de aporte de documentación?",
    TITULO_APORTE_OK: "Documentación aportada",
    MSG_APORTE_OK: "Se ha presentado la documentación aportada de forma correcta",
    PARTE_1_MSG_ERROR: "Se ha producido un error técnico.",
    PARTE_2_MSG_ERROR: " Puede volver a intentar realizar el proceso de firma y si el error persistiese contacte con el servicio de atención al ciudadano.</br></br>Teléfono: <b>"+appTexts.TLFN_JA+"</b></br>E-mail: <a href="+appTexts.MAIL_JA+">"+appTexts.MAIL_JA+"</a>",
}

export const properties = {
    URL_BANDEJA: '/BandejaSolicitudes',
    PATH_IMG_PDF: `${getContextFromUrl()}` + 'pdfGris.png',
    PATH_IMG_FOTO: `${getContextFromUrl()}` + 'imgGris.png',
    PATH_IMG_VIDEO: `${getContextFromUrl()}` + 'videoGris.png',
    TAM_MAX_ANEXO: propertiesCloudConfig['TAM_MAX_MEJ_DOCUMENTACION'],
    UN_MEGABYTE_EN_BYTE : 1000000,
    NUMERO_DECIMALES: 2,
    PROCESO_ENTREGA_APORTE: "APORTE_DOCUMENTACION",
    TIPO_DOC_MEJORA: "MEJORA_DOCUMENTACION",
    RESOURCE_PRESENTAR_SOLICITUD: "entregas",
    URL_PRESENTAR_SOLICITUD: '/presentacionEntrega',
    IMAGEN_ERROR : `${getContextFromUrl()}` + 'exclamation-triangle-solid.svg',
    IMAGEN_APORTE_OK: `${getContextFromUrl()}` + 'archivoOk.png',
    IMAGEN_CONFIRMAR: `${getContextFromUrl()}` + 'oval.png',
    PROCESO_ENTREGA_MEJORA_DOC: 'APORTE_DOCUMENTACION',
    RESOURCE_PRESENTAR_MEJORA_DOC_PCT3: 'presentacion-entrega',
    CODIGO_MEJ_MULTI :'MEJ_MULTI',
    RESOURCE_DATO_EXPEDIENTE: 'dato-expediente'
}

export const formato = ['.pdf'];